.plan-analytics-license-count {
  display: grid;
  grid-template-rows: subgrid;
  grid-template-columns: subgrid;
  grid-row: var(--lineup-plan-grid-row-analytics-license-label) / var(--lineup-plan-grid-row-divider);
  gap: var(--space-0);
}

.analytics-license-label {
  grid-area: analytics-license-label;
  color: var(--gray-212c36);
}

.analytics-license-input {
  grid-area: analytics-license;
  height: 32px;
  gap: var(--space-4);
  padding: var(--space-4) var(--space-4) var(--space-4) var(--space-8);
  font-size: 14px;

  > input {
    text-align: left;
  }
}
